import { INDUSTRIES } from "../data/mock";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export const IndustriesSection = () => {
  return (
    <section id="industries" className="py-24 lg:py-32 bg-[#FAFAF7]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="max-w-2xl mb-16">
          <span className="text-sm font-bold text-[#E95D54] uppercase tracking-widest mb-3 block">
            Who We Serve
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-[#2C2A2B] leading-tight mb-4">
            Depth Over Breadth —{" "}
            <span className="text-[#308795]">Industry Expertise That Matters</span>
          </h2>
          <p className="text-[#6B6567] text-lg leading-relaxed">
            We lead with deep domain knowledge in these Industry and Verticals,
            supported by proven solutions across key sectors.
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {INDUSTRIES.map((ind, i) => {
            const Icon = ind.icon;
            const content = (
              <div
                className={`group relative rounded-2xl border p-7 transition-all duration-400 hover:shadow-lg hover:-translate-y-1 cursor-pointer h-full ${
                  ind.featured
                    ? "bg-[#308795] border-[#308795] text-white sm:col-span-2 lg:col-span-1"
                    : "bg-white border-[#E0D1BB]/40 hover:border-[#308795]/30"
                }`}
              >
                {ind.featured && (
                  <span className="absolute top-4 right-4 text-[10px] font-bold uppercase tracking-widest bg-white/20 text-white px-3 py-1 rounded-full">
                    Featured
                  </span>
                )}
                <div
                  className={`w-14 h-14 rounded-xl flex items-center justify-center mb-5 ${
                    ind.featured ? "bg-white/15" : "bg-[#308795]/[0.06]"
                  }`}
                >
                  <Icon
                    className={`w-7 h-7 ${
                      ind.featured ? "text-white" : "text-[#308795]"
                    }`}
                  />
                </div>
                <h3
                  className={`text-lg font-bold mb-1.5 leading-snug ${
                    ind.featured ? "text-white" : "text-[#2C2A2B]"
                  }`}
                >
                  {ind.name}
                </h3>
                <p
                  className={`text-sm mb-5 ${
                    ind.featured ? "text-white/70" : "text-[#8A8385]"
                  }`}
                >
                  {ind.description}
                </p>
                <div
                  className={`flex items-center gap-1.5 text-sm font-semibold transition-all duration-300 ${
                    ind.featured
                      ? "text-[#E5BD77] group-hover:gap-3"
                      : "text-[#308795] group-hover:gap-3"
                  }`}
                >
                  Learn more
                  <ArrowRight className="w-4 h-4" />
                </div>
              </div>
            );

            return ind.href ? (
              <Link key={i} to={ind.href} className="block" onClick={() => window.scrollTo(0, 0)}>
                {content}
              </Link>
            ) : (
              <div key={i}>{content}</div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
